
import { getSchema, MergeField, MergeSchema } from '../../decorators';
import { ActivityEntityName, WorkOrder } from '../../../../entities';
import { ContactMergeData } from './contact.merge.data';

@MergeSchema({
    entity: ActivityEntityName.Job
})
export class JobMergeData {

    @MergeField()
    _id: string = ''

    @MergeField()
    jobNumber: string;

    @MergeField()
    status: string;

    @MergeField()
    name: string;

    @MergeField()
    mode: string;

    @MergeField()
    description: string;

    @MergeField()
    customerPO: string;

    @MergeField()
    customerWO: string;

    @MergeField()
    type: string;

    @MergeField()
    priority: string;

    @MergeField()
    tags: string;

    @MergeField()
    zones: string;

    @MergeField()
    startDate: string;

    @MergeField()
    dueDate: string;

    @MergeField()
    completedDate: string;

    @MergeField()
    finalisedDate: string = ''

    @MergeField()
    totalSell: string = ''

    @MergeField()
    totalBuy: string = ''

    @MergeField()
    pricebook: string = ''

    @MergeField()
    timezone: string = ''

    @MergeField()
    nextAppointmentDate: string = ''

    @MergeField()
    nextAppointmentDateTime: string = ''

    @MergeField()
    nextAppointmentResourceName: string = ''

    workOrders: WorkOrder[];

    [key: string]: any;
}

export const JobMergeSchema = getSchema(JobMergeData);
